import { ChangeDetectorRef, Component } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { AirdiskbrakeService } from 'src/app/services/feature/airdisk-brake/airdiskbrake.service';
import { Subject, Subscription } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
@Component({
  selector: 'app-airdisk-rust-maintainance',
  templateUrl: './airdisk-rust-maintainance.component.html',
  styleUrls: ['./airdisk-rust-maintainance.component.scss'],
  standalone: false
})
export class AirdiskRustMaintainanceComponent {
  private readonly destroy$ = new Subject<void>();
  fleetInfoData: any;
  frictionDrumMaintainance: any;
  subscription = new Subscription();
  isTractor: boolean = false;
  constructor(public airdiskService: AirdiskbrakeService, private readonly cdr: ChangeDetectorRef) { }

  ngOnInit() {
    this.subscription.add(this.airdiskService.selectedOption$.subscribe(option => {
      if (option) {
        this.isTractor = option === 'Tractor';
      } else {
        this.isTractor = true;
      }
    }));

    this.subscription.add(this.airdiskService.fleetInfoData$.subscribe(x => {
      this.fleetInfoData = x;
    }));

    this.subscription.add(this.airdiskService.frictionDrumMaintainance$.subscribe(y => {
      this.frictionDrumMaintainance = y;
    }));

    this.airdiskService.rustJackingMaintainance$.pipe(takeUntil(this.destroy$))
      .subscribe(data => {
        console.log('rustJackingMaintainance', data);
        if (data != null) {
          this.rustJackingMaintainanceForm.patchValue({
            drumBreakReplacementDueToRustJacking: data.drumBreakReplacementDueToRustJacking || 100,
            rustJackingShoeReplacementUnitCost: data.rustJackingShoeReplacementUnitCost || 219,
            rustJackingShoeReplacementFleetCost: data.rustJackingShoeReplacementFleetCost || 219000
          });

          if (this.isTractor) {
            this.rustJackingMaintainanceForm.controls['drumBreakReplacementDueToRustJacking'].setValue(100)
          } else {
            this.rustJackingMaintainanceForm.controls['drumBreakReplacementDueToRustJacking'].setValue(20);
          }
        }
      });
    this.calculateAndSetSum();
  }

  rustJackingMaintainanceForm = new FormGroup({
    drumBreakReplacementDueToRustJacking: new FormControl(100, { validators: Validators.required }),
    rustJackingShoeReplacementUnitCost: new FormControl(219, { validators: Validators.required }),
    rustJackingShoeReplacementFleetCost: new FormControl(219000, { validators: Validators.required })
  });
  get form() {
    return this.rustJackingMaintainanceForm.controls;
  }

  onFormChanges(): void {
    this.rustJackingMaintainanceForm.get('drumBreakReplacementDueToRustJacking')?.valueChanges.subscribe(() => {
      this.calculateAndSetSum();
    });

    this.storeDataOnChange();
  }

  calculateAndSetSum(): void {


    //fleetInfo
    const E21 = Number(this.fleetInfoData?.fleetDownTimeRate);
    const E14 = this.fleetInfoData?.totalNumberOfAxlesPerUnit;
    const E13 = this.fleetInfoData?.fleetSize;
    const E20 = this.fleetInfoData?.fleetMaintenanceLaborRate;

    //frictionDrumMaintainance
    const E32 = this.frictionDrumMaintainance?.drumBreakShoeReplacementUnitCost;

    const E54 = +this.rustJackingMaintainanceForm.get('drumBreakReplacementDueToRustJacking')?.value || 0;


    const E56 = ((E32 + E21) + (E14 * 2 * 1 * E20)) * E54; //=(E32+E21+E14*2*1*E20)*E54
    // e55 -- e150 -> =E151/E108
    const E55 = (E56 / E13);


    this.rustJackingMaintainanceForm.patchValue({
      rustJackingShoeReplacementUnitCost: E55,
      rustJackingShoeReplacementFleetCost: Math.round(E56)
    });

  }

  storeDataOnChange() {

    if (this.rustJackingMaintainanceForm.valid) {
      this.airdiskService.rustJackingMaintainance$.next(this.rustJackingMaintainanceForm.value);
    }
    else {
      this.rustJackingMaintainanceForm.markAllAsTouched();
    }
    this.cdr.detectChanges();
  }

  endaSureNxt() {
    this.storeDataOnChange();
    this.airdiskService.currentComponent$.next('costSummary');
  }

  endaSureBack() {
    this.airdiskService.currentComponent$.next('csaViolationCosts');
    this.storeDataOnChange();
  }

  ngOnDestroy() {
    // Complete the destroy$ subject to unsubscribe all subscriptions
    this.destroy$.next();
    this.destroy$.complete();
    this.subscription.unsubscribe();
  }

}
